import React, { useEffect, useCallback, useRef } from "react";
import {
    Box,
    // List,
    ListItem,
    Card,
    CardContent,
    // Accordion,
    // AccordionSummary,
    // AccordionDetails
} from '@mui/material';
import { useState } from '@hookstate/core';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';
import { useEventState } from '../../stores/eventStore';
import EnhancedTableToolbar from '../../sharedcomponents/tableToolbar/tableToolbar';
import Paging from '../../sharedcomponents/pagination/pagination';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import Title from '../../sharedcomponents/title/title';
import DataOutfitRow from './dataOutfitRow';
import Helper from "../../utility/helper";
import { VariableSizeList as LoadDataList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { useWindowResize } from '../../utility/useWindowResize';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const theme = createTheme();

const useStyles = makeStyles(() => ({
    boxContent: {
        // paddingTop: theme.spacing(2),
    },
    listContent: {
        paddingBottom: theme.spacing(0),
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordionMain: {
        '& .MuiButtonBase-root': {
            '& .Mui-expanded': {
                // minHeight: theme.spacing(4)
            }
        }
    },
    accordion: {
        backgroundColor: '#cccccc',

    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600
    },
    addPadding: {
        margin: theme.spacing(0),
    },
    addTopPad: {
        padding: theme.spacing(1, 0.5),
    },
}));

// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';




const DataOutfitList = (props) => {
    const classes = useStyles();
    const [listData, setListData] = React.useState([]);
    const [search, setSearch] = React.useState('');
    const [filterListData, setFilterListData] = React.useState([]);
    const eventState = useEventState();
    const moduleIndex = useState(-1)
    const userInfo = Helper.getStorage('userInfo');

    const listRef = useRef();

    const sizeMap = useRef({});
    const setSize = useCallback((index, size) => {
        sizeMap.current = { ...sizeMap.current, [index]: size };
        listRef.current.resetAfterIndex(index);
    }, []);
    const getSize = index => sizeMap.current[index] || 40;
    const [windowWidth] = useWindowResize();

    useEffect(() => {
        if (listData && listData.length == 0 && filterListData.length == 0) {
            setListData(props.data);
            setFilterListData(props.data);
        }
        else if (props.showSearchRec && props.data.length != listData.length) {
            setListData(props.data);
            setFilterListData(props.data);
        }
        else if (!props.showSearchRec) {
            setListData(props.data);
            setFilterListData(props.data);
        }

        if (eventState && eventState.eventDetail.get() != null && props.moduleToShow != undefined) {
            getModuleDetailsData();
        }

    }, [props]);

    const getModuleDetailsData = () => {
        const index = eventState.eventDetail.get().moduleDetails.findIndex((element) => {
            if (element.moduleName === props.moduleToShow) {
                return true
            }
        });
        if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo))) {
            moduleIndex.set(index);
        }
    }

    const handleOnChange = (event) => {
        let str = event.target.value;
        const value = str.replace(/^\s+/g, '');
        setSearch(value);
        if (value.length > 0) {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(true);
            }
            let modifyList = [];
            listData.forEach((item) => {
                let data = item;
                let keys = Object.keys(data);
                keys.forEach((key) => {
                    if (
                        typeof data[key] === 'string' &&
                        data[key].toLowerCase().indexOf(value.toLowerCase()) > -1
                    ) {
                        if (modifyList.indexOf(item) == -1)
                            modifyList.push(item);
                    }
                });
            });
            setFilterListData(modifyList);
            // props.filterListData(modifyList)

        } else {
            if (props.setShowSearchRec != undefined) {
                props.setShowSearchRec(false);
            }
            setFilterListData(listData);
            // props.filterListData(listData)
        }
    };
    const onCheckSelect = (event, index) => {
        let newFilterList = [...filterListData];
        newFilterList[index]['selected'] = event.target.checked;
        setFilterListData(newFilterList);
    }

    const Row = ({ data, index, setSize, windowWidth }) => {
        const rowRef = useRef();
        useEffect(() => {
            setSize(index, rowRef.current.getBoundingClientRect().height);
        }, [setSize, index, windowWidth]);

        const item = data[index];

        return (
            <div ref={rowRef} className={classes.addTopPad}>
                <DataOutfitRow
                    item={item}
                    index={index}
                    onCheckSelect={onCheckSelect}
                    editRow={props.editRow}
                    editTemplate={props.editTemplate}
                    editSendEmail={props.editSendEmail}
                    viewPage={props.viewPage}
                    onSwitchToggle={props.onSwitchToggle}
                    onActionClick={props.onActionClick}
                    onPendingAction={props.onPendingAction}
                    addConnection={props.addConnection}
                    addConnectionLinkedWith={props.addConnectionLinkedWith}
                    deleteConnection={props.deleteConnection}
                    modPermission={props.modPermission}
                    copyToClipboard={props.copyToClipboard}
                    outfitInfo={props.outfitInfo}
                    toggleChange={props.toggleChange}
                    callExport={props.callExport}
                />
            </div>
        )
    }

    return (
        <Box className={classes.boxContent}>
            <Title title={props.moduleDisplayName ? props.moduleDisplayName : props.moduleToShow} />
            {
                props.moduleToShow != undefined && eventState.eventDetail.get() &&
                (moduleIndex.get() >= 0 && eventState.eventDetail.get().moduleDetails[moduleIndex.get()].details != null || "") &&
                <DetailsComponent data={eventState.eventDetail.get().moduleDetails[moduleIndex.get()].details} />
            }
            <EnhancedTableToolbar
                {...props}
                search={search}
                showSendAll={props.showSendAll ? true : false}
                sendAllbuttonTitle={props.showSendAll ? "Send All" : null}
                showEdit={props.showEdit ? true : false}
                editButtonTitle={props.showEdit ? true : false}
                handleSearchChange={handleOnChange}
                handleSendEmail={props.handleSendEmail}
                hideAdd={props.hideAdd ? true : false}
                modPermission={props.modPermission}
                disableAdd={props.disableAdd}
            />
            {filterListData && filterListData.length > 0 ? (
                <div style={{ display: 'flex', height: '68vh' }}>
                    <div style={{ flex: '1 1 auto' }}>
                        <AutoSizer>
                            {({ height, width }) => (
                                <LoadDataList
                                    ref={listRef}
                                    itemData={filterListData}
                                    className="List"
                                    height={height}
                                    itemCount={filterListData.length}
                                    itemSize={getSize}
                                    width={width}
                                >
                                    {({ data, index, style }) => (
                                        <div style={style} className={classes.addPadding}>
                                            <Row
                                                data={data}
                                                index={index}
                                                setSize={setSize}
                                                windowWidth={windowWidth}
                                            />
                                        </div>
                                    )}
                                </LoadDataList>
                            )}
                        </AutoSizer>
                    </div>
                </div>
            )
                // {filterListData && filterListData.length > 0 ? (
                //     filterListData.map((item, index) => (
                //         <DataOutfitRow
                //             key={`datarow_${index}`}
                //             item={item}
                //             index={index}
                //             onCheckSelect={onCheckSelect}
                //             editRow={props.editRow}
                //             editTemplate={props.editTemplate}
                //             editSendEmail={props.editSendEmail}
                //             viewPage={props.viewPage}
                //             onSwitchToggle={props.onSwitchToggle}
                //             onActionClick={props.onActionClick}
                //             onPendingAction={props.onPendingAction}
                //             addConnection={props.addConnection}
                //             addConnectionLinkedWith={props.addConnectionLinkedWith}
                //             deleteConnection={props.deleteConnection}
                //             modPermission={props.modPermission}
                //             copyToClipboard={props.copyToClipboard}
                //             outfitInfo={props.outfitInfo}
                //             toggleChange={props.toggleChange}
                //             callExport={props.callExport}
                //         />
                //     ))
                // ) 
                : (
                    <ListItem className={classes.listItemContent}>
                        <Card
                            classes={{ root: classes.paperContent }}
                            sx={{ width: '100%' }}>
                            <CardContent
                                sx={{ p: 2 }}
                                className={classes.cardContent}>
                                <Box className={classes.rowContent}>
                                    No data found
                                </Box>
                            </CardContent>
                        </Card>
                    </ListItem>
                )}
            {/* </List> */}

            {props.pagingInfo && props.pagingInfo.noOfPages > 1 && !props.showSearchRec ? (
                <Box
                    sx={{
                        p: 2,
                        display: 'flex',
                        width: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Paging
                        pagingInfo={props.pagingInfo}
                        handlePageChange={props.handlePageChange}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
export default DataOutfitList;